import apiClient from "../apiClient";
import authClient from "../authClient";

const REACT_APP_CLIENT_ID = process.env.REACT_APP_CLIENT_ID;
const REACT_APP_CLIENT_SECRET = process.env.REACT_APP_CLIENT_SECRET;

export const AuthAPI = {
  validateClient: () =>
    authClient.post("/api/v1/auth/validate-client", {
      ClientID: REACT_APP_CLIENT_ID,
      ClientSecret: REACT_APP_CLIENT_SECRET,
    }),
  authUser: (username, password) =>
    apiClient.post("/api/v1/authentication/user", {
      email: username,
      password,
    }),
};
